"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Money = void 0;
class Money {
    static get multiplier() {
        return Math.pow(10, this.digitsAfterDot);
    }
    static toSafeInteger(value) {
        return +(this.multiplier * parseFloat(value)).toFixed(0);
    }
    static fromSafeInteger(value) {
        return +(value / this.multiplier).toFixed(this.digitsAfterDot);
    }
    static toSafeFloat(value) {
        return this.fromSafeInteger(this.toSafeInteger(value));
    }
    static postgresType(Sequelize) {
        return Sequelize.NUMERIC(this.postgresNumericParameters);
    }
    static get postgresNumericParameters() {
        return {
            precision: 10 + this.digitsAfterDot,
            scale: this.digitsAfterDot
        };
    }
}
exports.Money = Money;
Money.digitsAfterDot = 4;
//# sourceMappingURL=Money.js.map